
import Form from "./Form.vue";
import TecnicoData from "./TecnicoData";
import { mapGetters } from "vuex";

export default {
  name: "app-tecnico-create",
  data() {
    return {
      tecnico: new TecnicoData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
